import { atom } from 'jotai';

export interface IFeatureFlag {
    id?: number;
    flag_name: string;
    development_value: boolean;
    production_value: boolean;
    is_active: boolean;
}

export const featureFlagsAtom = atom<IFeatureFlag[]>([]);
export const featureFlagsLoadingAtom = atom<boolean>(false);

